import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { loadGlobals } from '../actions'

import FaIcon from '../components/FaIcon'
import DataTable from '../components/DataTable'
import TableButton from '../components/TableButton';
import { message } from 'antd';



class Registrations extends Component {

    state = {
        data: [],
        loading: false
    }

    static propTypes = {
        loadGlobals: PropTypes.func.isRequired,
        comboboxes: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    fetch = (params = {}) => {
        const { intl, comboboxes } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'registrations'
        }).then((data) => {
            this.setState({
                data: each(data, (item) => {
                    item.fullName = item.firstName + ' ' + item.lastName
                    item.language = comboboxes.byKey.language[item.language].value
                    item.addressCountry = comboboxes.byKey.country[item.addressCountry].value
                }),
                loading: false
            })
        }).catch((err) => {
            console.log(err);
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    accept = (registration) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'registrations/' + registration.id + '/validate',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'registrations.validated'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    reject = (registration) => {
        const { intl, loadGlobals } = this.props
        callApi({
            endpoint: 'registrations/' + registration.id + '/reject',
            method: 'POST'
        }).then((data) => {
            message.success(intl.formatMessage({id: 'registrations.rejected'}))
            this.fetch()
            loadGlobals()
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
        })
    }

    render() {
        const { data, loading } = this.state

        const columns = [
            { title: "registrations.nameColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "registrations.emailColumn", dataIndex: "email", type: "string", sorter: true },
            { title: "registrations.countryColumn", dataIndex: "addressCountry", type: "string", sorter: true },
            { title: "registrations.languageColumn", dataIndex: "language", type: "string", sorter: true },
            { title: "registrations.emailValidatedColumn", dataIndex: "emailValidated", type: "boolean" },
            { title: "registrations.registrationDateColumn", dataIndex: "registrationDate", type: "date", sorter: true },
            { title: "misc.actions", width: "100px", key: "action", render: (record) => (
                <span>
                    <TableButton color="green" icon="check" onClick={this.accept} value={record} confirm disabled={!record.emailValidated} tip={<FormattedMessage id="registrations.acceptTooltip" />} />
                    <TableButton color="red" icon="times" onClick={this.reject} value={record} confirm tip={<FormattedMessage id="registrations.rejectTooltip" />} />
                </span>
            ) }
        ]

        return (
            <div>
                <h1><FaIcon icon="user-plus" fixedWidth /> <FormattedMessage id="registrations.title" /></h1>
                <DataTable columns={columns} dataSource={data} loading={loading} rowKey="id" size="middle" />
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default injectIntl(connect(mapStateToProps, {
    loadGlobals
})(Registrations))


// WEBPACK FOOTER //
// ./src/views/Registrations.js